const ChapterImage = (props: {src: string}) => <img src={props.src} alt="" style={{width: 168, maxWidth: "100%"}}/>
export default ChapterImage;
